import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from 'apps/webcomponents/src/types/common/types';

export const templateBreachPathDetails = document.createElement('template');

templateBreachPathDetails.innerHTML = `
  <style>
    ${widgetSharedStyles}
  </style>
  <style>
    ${colorHelpersStyles}
  </style>
  <style>
    ${flexboxHelpersStyles}
  </style>
  <style>
    ${styleHelpers}
  </style>
  <style>
    ${textHelpersStyles}
  </style>
  <style>
    ${commonStyles}
  </style>
  <style>
    ${styles}
  </style>

  <div class="d-flex flex-column h-full">
    <div class="header-section">
      <div id="back-button">
        <gz-icon
          name='ds-icon-arrow_left_collapse'
          size="24"
          color="secondary"
        ></gz-icon>
        <gz-button
          type="quiet"
          color="secondary"
          buttonHeight="small"
          id="back-button-text"
        ></gz-button>
      </div>

      <gz-page-navigation-header></gz-page-navigation-header>
    </div>

    <gz-tab-group id="tab-group">

      <gz-tab id="graph-tab">
        <gz-push-body-layout resizable="right">
          <div slot="push-body-sidenav-title"></div>
          <div slot="push-body-sidenav"></div>
          <div slot="push-body-content-header"></div>
          <div slot="push-body-content-toolbar"></div>
          <slot slot="push-body-content" name="issue-graph-extjs-slot"></slot>
        </gz-push-body-layout>
      </gz-tab>

      <gz-tab id="resources-tab" style="overflow: auto;">
        <div class="resources-tab-content">
          <div>
            <gz-title
              id="main-grid-title"
              class="mb-3"
              fontweight="${FontWeights.MEDIUM}"
              fontsize="${FontSizes.TITLE}"
            ></gz-title>
            <gz-loader rows="2"></gz-loader>
            <gz-grid-view
              id="main-resource-grid"
              removeFilters
              hideFiltersToggle
              hideGridRefresh
              disableGridSettings
              hideHeaderActions
              hideFooter
              style="height: 81px;"
            ></gz-grid-view>
          </div>
          <div>
            <gz-title
              id="other-grid-title"
              class="mb-3"
              fontweight="${FontWeights.MEDIUM}"
              fontsize="${FontSizes.TITLE}"
            ></gz-title>
            <gz-loader rows="5"></gz-loader>
            <gz-grid-view
              id="other-resource-grid"
              removeFilters
              hideFiltersToggle
              hideGridRefresh
              disableGridSettings
              hideHeaderActions
              hideFooter
              dynamicHeight
            ></gz-grid-view>
          </div>
        </div>
      </gz-tab>

      <gz-side-menu
        id="detailsSideMenu"
        menuwidth="400"
        closeOnClickOutside
        resizable="left"
      ></gz-side-menu>

      <gz-side-menu
        id="metadataSideMenu"
        menuwidth="400"
        closeOnClickOutside
        resizable="left"
      ></gz-side-menu>

    </gz-tab-group>
  </div>
`;
